import React from 'react';
import { PageHeader } from '../components/common';
import { ROUTES } from '../constants';

const RolesPage = () => {
  return (
    <div>
      <PageHeader
        title='Roles & Permissions'
        subtitle='Manage user roles and their permissions'
        breadcrumbs={[
          { name: 'Home', href: ROUTES.DASHBOARD },
          { name: 'Roles' },
        ]}
      />

      <div className='grid grid-cols-1 lg:grid-cols-3 gap-6'>
        {/* Roles List */}
        <div className='lg:col-span-1'>
          <div className='bg-white rounded-lg shadow-sm border border-gray-200'>
            <div className='px-6 py-4 border-b border-gray-200 flex justify-between items-center'>
              <h3 className='text-lg font-medium text-gray-900'>Roles</h3>
              <button className='bg-blue-600 text-white px-3 py-1 rounded-md text-sm font-medium hover:bg-blue-700'>
                Add Role
              </button>
            </div>

            <div className='p-6'>
              <div className='space-y-3'>
                {[
                  { name: 'Super Admin', users: 2, color: 'purple' },
                  { name: 'Admin', users: 5, color: 'blue' },
                  { name: 'Marketer', users: 89, color: 'green' },
                  { name: 'User', users: 1138, color: 'gray' },
                ].map((role, index) => (
                  <div
                    key={index}
                    className={`p-3 rounded-lg border-2 cursor-pointer transition-colors ${
                      index === 1
                        ? 'border-blue-200 bg-blue-50'
                        : 'border-gray-200 hover:border-gray-300'
                    }`}
                  >
                    <div className='flex items-center justify-between'>
                      <div className='flex items-center'>
                        <div
                          className={`w-3 h-3 rounded-full bg-${role.color}-500 mr-3`}
                        ></div>
                        <div>
                          <h4 className='font-medium text-gray-900'>
                            {role.name}
                          </h4>
                          <p className='text-sm text-gray-500'>
                            {role.users} users
                          </p>
                        </div>
                      </div>
                      <button className='text-gray-400 hover:text-gray-600'>
                        <svg
                          className='w-5 h-5'
                          fill='none'
                          stroke='currentColor'
                          viewBox='0 0 24 24'
                        >
                          <path
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            strokeWidth={2}
                            d='M9 5l7 7-7 7'
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Role Details */}
        <div className='lg:col-span-2'>
          <div className='bg-white rounded-lg shadow-sm border border-gray-200'>
            <div className='px-6 py-4 border-b border-gray-200 flex justify-between items-center'>
              <div>
                <h3 className='text-lg font-medium text-gray-900'>
                  Admin Role
                </h3>
                <p className='text-sm text-gray-500'>
                  Manage permissions for Admin role
                </p>
              </div>
              <div className='flex gap-2'>
                <button className='bg-gray-100 text-gray-700 px-3 py-1 rounded-md text-sm font-medium hover:bg-gray-200'>
                  Edit Role
                </button>
                <button className='bg-red-600 text-white px-3 py-1 rounded-md text-sm font-medium hover:bg-red-700'>
                  Delete Role
                </button>
              </div>
            </div>

            <div className='p-6'>
              <div className='space-y-6'>
                {[
                  {
                    category: 'User Management',
                    permissions: [
                      { name: 'View Users', enabled: true },
                      { name: 'Create Users', enabled: true },
                      { name: 'Edit Users', enabled: true },
                      { name: 'Delete Users', enabled: false },
                    ],
                  },
                  {
                    category: 'Content Management',
                    permissions: [
                      { name: 'View Content', enabled: true },
                      { name: 'Create Content', enabled: true },
                      { name: 'Edit Content', enabled: true },
                      { name: 'Delete Content', enabled: true },
                    ],
                  },
                  {
                    category: 'Marketer Management',
                    permissions: [
                      { name: 'View Marketers', enabled: true },
                      { name: 'Create Marketers', enabled: true },
                      { name: 'Edit Marketers', enabled: false },
                      { name: 'Delete Marketers', enabled: false },
                    ],
                  },
                  {
                    category: 'System Settings',
                    permissions: [
                      { name: 'View Settings', enabled: true },
                      { name: 'Edit Settings', enabled: false },
                      { name: 'Manage Roles', enabled: false },
                      { name: 'View Analytics', enabled: true },
                    ],
                  },
                ].map((section, index) => (
                  <div key={index}>
                    <h4 className='text-md font-medium text-gray-900 mb-3'>
                      {section.category}
                    </h4>
                    <div className='grid grid-cols-1 md:grid-cols-2 gap-3'>
                      {section.permissions.map((permission, permIndex) => (
                        <div key={permIndex} className='flex items-center'>
                          <input
                            type='checkbox'
                            checked={permission.enabled}
                            className='h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded'
                            readOnly
                          />
                          <label className='ml-2 text-sm text-gray-700'>
                            {permission.name}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>

              <div className='mt-8 pt-6 border-t border-gray-200'>
                <div className='flex justify-end gap-2'>
                  <button className='bg-gray-100 text-gray-700 px-4 py-2 rounded-md text-sm font-medium hover:bg-gray-200'>
                    Cancel
                  </button>
                  <button className='bg-blue-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-blue-700'>
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RolesPage;
